import { render, staticRenderFns } from "./NpsModal.vue?vue&type=template&id=6c08fe67&scoped=true&"
import script from "./NpsModal.vue?vue&type=script&lang=js&"
export * from "./NpsModal.vue?vue&type=script&lang=js&"
import style0 from "./NpsModal.vue?vue&type=style&index=0&id=6c08fe67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08fe67",
  null
  
)

export default component.exports